module.exports = __webpack_public_path__ + "static/fonts/DingTalk+JinBuTi.f32de78.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/DingTalk+JinBuTi.woff2
// module id = /MGO
// module chunks = 66